import { getCommonApplicationQueryOptions } from '@src/features/common-application/api/get-common-application';
import { createFileRoute, isRedirect, redirect } from '@tanstack/react-router';
import ApplicationSuccessLayout from './-layouts/application-success-layout';

export const Route = createFileRoute(
  '/_authenticated-chromeless/application-success',
)({
  beforeLoad: async ({ context }) => {
    try {
      const application = await context.queryClient.fetchQuery(
        getCommonApplicationQueryOptions,
      );
      if (!application?.complete) {
        // eslint-disable-next-line @typescript-eslint/only-throw-error
        throw redirect({ to: '/dashboard' });
      }
    } catch (error) {
      if (isRedirect(error)) {
        throw error;
      }
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/dashboard' });
    }
  },
  component: ApplicationSuccessLayout,
});
